import React from "react";
import { Flex, Icon, Text, Avatar, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { Home, Star } from "react-feather";
import { StarIcon } from "@chakra-ui/icons";
import { useSession } from "next-auth/react";

import { getDistanceLabel } from "@/utils/distance";
import { Garage } from "@/types/user";
import { onLikeOrDislikeGarage } from "@/utils/garage";

type Props = {
  garage: Garage;
  productRefresher: () => void;
};

const GarageInfo = ({
  garage,
  productRefresher,
}: Props): React.ReactElement => {
  const { t } = useTranslation();
  const router = useRouter();
  const { status } = useSession();

  return (
    <Flex alignItems={"flex-start"} justifyContent="space-between">
      <Flex
        onClick={() => router.push(`/g/${garage?.slug}`)}
        _hover={{
          cursor: "pointer",
          opacity: 0.7,
        }}
        transition="opacity .25s ease-in-out"
        align="center"
      >
        <Avatar
          bg="red.500"
          src=""
          icon={<Icon as={Home} color="white" w="30px" h="30px" />}
          mr="20px"
        />
        <Flex direction="column" gap="5px" lineHeight={1.2}>
          <Text fontWeight="bold">{garage?.name}</Text>
          {garage?.distance && (
            <Text fontStyle="italic" fontSize="14px">
              {t("kilometersFromYouShort", {
                distance: getDistanceLabel(t, garage?.distance, false),
              })}
            </Text>
          )}
          <Text fontSize="14px">{garage?.publicAddress}</Text>
        </Flex>
      </Flex>

      {status === "authenticated" && (
        <Tooltip
          label={
            garage?.liked ? t("removeFromFavourites") : t("addToFavourites")
          }
          placement="top"
        >
          <Icon
            cursor="pointer"
            as={garage?.liked ? StarIcon : Star}
            w={8}
            h={8}
            color="yellow.500"
            onClick={() =>
              onLikeOrDislikeGarage(
                garage?.id,
                !garage?.liked,
                productRefresher
              )
            }
          />
        </Tooltip>
      )}
    </Flex>
  );
};

export default GarageInfo;
